export enum BookingStatus {
  New = "New",
  Quote = "Quote",
  Reserved = "Reserved",
  ContractCreated = "ContractCreated",
  Cancelled = "Cancelled",
  NoShow = "NoShow",

  NewContract = "NewContract",
  Confirm = "Confirmed",
  ContractSigned = "ContractSigned",
  CheckedOut = "CheckedOut",
  PaymentPending = "PaymentPending",
  Completed = "Completed",
  Void = "Void",
  NoShowContract = "NoShowContract",
}

export enum ContractStatus {
  New = "New",
  Confirm = "Confirmed",
  ContractSigned = "ContractSigned",
  CheckedOut = "CheckedOut",
  PaymentPending = "PaymentPending",
  Completed = "Completed",
  Void = "Void",
  NoShow = "NoShow",
  CheckIn = "CheckIn",
}

export enum BookingAction {
  CreateNew = "CreateNew",
  CreateQuote = "CreateQuote",
  Reserve = "Reserve",
  Cancel = "Cancel",
  CreateContract = "CreateNew",
  NoShow = "NoShow",
  // CreateNew = "CreateNew",
  SignContract = "SignContract",
  Void = "Void",
  Checkout = "Checkout",
  CheckIn = "CheckIn",
  Confirm = "Confirm",
  // NoShow = "NoShow",
  CompleteContract = "CompleteContract",
  NA = "NA",
}

export enum ContractAction {
  CreateNew = "CreateNew",
  SignContract = "SignContract",
  Void = "Void",
  Checkout = "Checkout",
  CheckedOut = "CheckedOut", //it needed now
  CheckIn = "CheckIn",
  Confirm = "Confirm",
  NoShow = "NoShow",
  CompleteContract = "CompleteContract",
  VehicleExchange = "VehicleExchange",
  NA = "NA",
}

export enum RentContractStatus {
  New = "New",
  Active = "Active",
  Completed = "Completed",
  Terminated = "Terminated",
  Void = "Void",
}

export enum RentContractType {
  Retail = "Retail",
  // OneWay = "OneWay",
  Insurance = "Insurance",
  Internal = "Internal",
}

export enum OpenEndedBillingPeriod {
  Weekly = 1,
  Monthly = 2,
}

export enum bookingStatusIds {
  New = 100,
  Quote = 101,
  Reserved = 102,
}
export enum contractStatusIds {
  New = 1,
  Confirmed = 2,
  ContractSigned = 3,
  CheckedOut = 4,
  PaymentPending = 5,
  Completed = 6,
}

export enum ContractBillingBy {
  Customer = 1,
  Insurance = 2,
  Company = 3,
}

export enum InsuranceClaimStatus {
  Pending = 1,
  Extended = 2,
  Max = 3,
  Rejected = 4,
  Final = 5,
}

export enum TodoStatus {
  New = "New",
  Inprogress = "Inprogress",
  Resolved = "Resolved",
}

export enum TodoPriority {
  High = "High",
  Medium = "Medium",
  Low = "Low",
}
